module.exports = __webpack_public_path__ + "assets/media/july-1@2x.3d8b4c78.png";